module.exports = __webpack_public_path__ + "img/index-form.c9d84772.png";